let ctx = null;

export function unlockAudio() {
  if (!ctx) ctx = new (window.AudioContext || window.webkitAudioContext)();
  if (ctx.state === "suspended") ctx.resume();
  return ctx;
}

// Loud two-tone alarm, ~3 seconds.
export function playAlarm(repeats = 6) {
  try {
    const ac = unlockAudio();
    const master = ac.createGain();
    master.gain.value = 1;
    master.connect(ac.destination);
    let t = ac.currentTime;
    for (let i = 0; i < repeats; i++) {
      [1046, 1568].forEach((freq) => {
        const osc = ac.createOscillator();
        const g = ac.createGain();
        osc.type = "square";
        osc.frequency.value = freq;
        g.gain.setValueAtTime(0.9, t);
        g.gain.exponentialRampToValueAtTime(0.01, t + 0.24);
        osc.connect(g).connect(master);
        osc.start(t);
        osc.stop(t + 0.25);
        t += 0.25;
      });
    }
    if (navigator.vibrate) navigator.vibrate([400, 150, 400, 150, 400]);
  } catch (e) {
    console.warn("Ses çalınamadı", e);
  }
}
